export default __webpack_public_path__ + "static/media/retiro_seclantas4.97bcbced.jpg";